import AccountFields from '@/views/backstage/structure/system_management_page/account_management_page/common/AccountManagementFields'

let account_structure = {
    name: '帳號管理',
    type: 'group',
    fields: [].concat(
        AccountFields['id'],
        AccountFields['username'],
        AccountFields['org_name'],
        AccountFields['email'],
        // #216
        // AccountFields['password'],
        AccountFields['roles'],
    )
}

export default () => {
    return account_structure
}